interface Props {
  /** 例: "10周年" "20歳" */
  label: string;
}

/**
 * 節目の記念日カードの右上に乗せるコーナーリボン。
 * 親要素は `relative overflow-hidden` を持つこと(→ AnniversaryManager, Schedule)。
 */
export default function MilestoneRibbon({ label }: Props) {
  return (
    <span
      aria-label={`節目・${label}`}
      className="absolute top-3 -right-8 w-32 rotate-[38deg] bg-gradient-to-r from-[var(--color-gold)] to-[var(--color-plum)] py-0.5 text-center text-[9.5px] font-bold text-white shadow"
    >
      {label}
    </span>
  );
}
